import React from 'react';

import useStyles from './Style';

const Link = (props) => {
    const classes = useStyles();

    return (
        <a className={classes.link} href={`#anchor-${props.anchor}`} >
            {props.children}
        </a>
    )
}

const NavbarFAQ = () => {
    const classes = useStyles();

    return (
        <div className={classes.nav}>
            <Link anchor="01"> » OLIMPÍADA DE PROFESSORES DA OBMEP MIRIM</Link>
            <Link anchor="02"> » INSCRIÇÃO</Link>
            <Link anchor="03"> » PROVAS</Link>
            <Link anchor="04"> » PREMIAÇÃO</Link>
        </div>
    )
}

export default NavbarFAQ;